import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08b7bbbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-internet-modal__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/no-internet-icon.svg",
    alt: ""
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "no-internet-modal__title" }, "No internet connection", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/refresh-icon.svg",
  alt: ""
}, null, -1))

import { ref } from 'vue';
import { IonSpinner } from '@ionic/vue';
import { Network } from '@capacitor/network';
import { usePopup } from '@/composables/usePopup';

import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoInternetModal',
  props: {
    isOpened: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const { toggleErrorPopup } = usePopup();

const props = __props;
const emit = __emit;

const isClose = ref(false);
const isLoading = ref(false);

async function reload() {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  const status = await Network.getStatus();
  isLoading.value = false;
  if (status.connected) {
    isClose.value = true;
    emit('close');
  } else {
    toggleErrorPopup('No internet connection');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    "is-hide-close": "",
    "is-not-close-outside": !isClose.value,
    class: "no-internet-modal"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(BaseButton, {
        class: "no-internet-modal__button",
        onClick: reload
      }, {
        default: _withCtx(() => [
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(IonSpinner), { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_3,
                _createTextVNode(" Reload ")
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-opened", "is-not-close-outside"]))
}
}

})